"use client";

import React, { useEffect } from "react";
import { cn } from "@/lib/utils";
import { createPortal } from "react-dom";

interface CustomFullScreenModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export const FullScreenModal: React.FC<CustomFullScreenModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  return createPortal(
    <div
      className={`fixed w-screen h-screen max-h-screen inset-0 z-20 flex items-center justify-center transition-opacity duration-300 ${
        isOpen
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-75" onClick={onClose} />

      {/* Modal Content */}
      <div
        className={cn(
          "relative w-full h-full mx-auto bg-white rounded-lg shadow-lg overflow-hidden",
          className,
        )}
      >
        <main className="flex flex-col max-h-full h-full">{children}</main>
      </div>
    </div>,
    document.body,
  );
};
